import {useState} from 'react'
import ProcurementTemplateList from './ProcurementTemplateList';
import ProcurementTemplateForm from './ProcurementTemplateForm';

const ProcurementTemplate = () => {
  const [fromIsShown, setFromIsShown] = useState(false);
  const [upData, setUpData] = useState(false);
  const [serviceId, setServiceId] = useState("none");
return (
  <>
    {fromIsShown ? (
        <ProcurementTemplateForm addForm={setFromIsShown} update={upData} sId={serviceId}/>
      ) : (
        <ProcurementTemplateList addForm={setFromIsShown} update={setUpData} sId={setServiceId}/>
      )}

  </>
  )
}

export default ProcurementTemplate

